// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c01b9bf1","977":"a53657cc"}[chunkId] + ".chunk.js";
};